import { render, staticRenderFns } from "./activityCooperate.vue?vue&type=template&id=5046a742&scoped=true"
import script from "./activityCooperate.vue?vue&type=script&lang=js"
export * from "./activityCooperate.vue?vue&type=script&lang=js"
import style0 from "./activityCooperate.vue?vue&type=style&index=0&id=5046a742&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5046a742",
  null
  
)

export default component.exports